var _path, _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssignedUsersRolesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 114H129.5C147 114 154 107 154 89.5V68.5C154 51 147 44 129.5 44H108.5C91 44 84 51 84 68.5V89.5C84 107 91 114 108.5 114Z",
    fill: "url(#paint0_linear_441_75414)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_441_75414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint1_linear_441_75414)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_441_75414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint2_linear_441_75414)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    stroke: "url(#paint3_linear_441_75414)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_441_75414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5 110.75V107.25C112.5 103.988 110.269 101.248 107.25 100.471M101.125 79.7588C103.69 80.7973 105.5 83.3123 105.5 86.25C105.5 89.1877 103.69 91.7027 101.125 92.7412M103.75 110.75C103.75 107.488 103.75 105.858 103.217 104.571C102.507 102.856 101.144 101.493 99.4288 100.783C98.1424 100.25 96.5116 100.25 93.25 100.25H88C84.7384 100.25 83.1076 100.25 81.8212 100.783C80.106 101.493 78.7433 102.856 78.0328 104.571C77.5 105.858 77.5 107.488 77.5 110.75M97.625 86.25C97.625 90.116 94.491 93.25 90.625 93.25C86.759 93.25 83.625 90.116 83.625 86.25C83.625 82.384 86.759 79.25 90.625 79.25C94.491 79.25 97.625 82.384 97.625 86.25Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_441_75414",
    x: 0,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_441_75414"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_441_75414",
    x: 43.25,
    y: 43.25,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_441_75414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_441_75414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_441_75414",
    x: 76,
    y: 77.75,
    width: 38,
    height: 36.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_75414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_441_75414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_75414",
    x1: 89,
    y1: 51,
    x2: 142,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_441_75414",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_441_75414",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_441_75414",
    x1: 123,
    y1: 66,
    x2: 66,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedUsersRolesEmpty);
export default __webpack_public_path__ + "static/media/assignedUsersRolesEmpty.d1137667986c1c6e5556b1d71fbd110b.svg";
export { ForwardRef as ReactComponent };